import { GeneralAPI } from '../apis/GeneralAPI'
import Header from '../components/Header'
import HeroSection from '../components/BetterDirectMail/HeroSection'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import InvestorsSay from '../components/BetterDirectMail/InvestorsSay'
import SwitchOLMFAQs from '../components/BetterDirectMail/SwitchOLMFAQs'
import FreeCallKeySection from '../components/BetterDirectMail/FreeCallKeySection'
import CompetitorsTable from '../components/BetterDirectMail/CompetitorsTable'
import SwitchOLMBenefits from '../components/BetterDirectMail/SwitchOLMBenefits'
import OlmEdge from '../components/BetterDirectMail/OlmEdge'
import FreeResources from '../components/BetterDirectMail/FreeResources'
import SwitchProcess from '../components/BetterDirectMail/SwitchProcess'
import CallMailboxProcess from '../components/BetterDirectMail/CallMailboxProcess'

export default function BetterDirectMail({ data }) {
    return (
        <LandingPageWrapper>
            <Header meta={data?.yoast_head} />
            <HeroSection />
            <SwitchProcess />
            <SwitchOLMBenefits />
            <CompetitorsTable />
            <InvestorsSay />
            <OlmEdge />
            <CallMailboxProcess />
            <FreeCallKeySection />
            <FreeResources />
            <SwitchOLMFAQs />
        </LandingPageWrapper>
    )
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps() {
    // const data = { } //await GeneralAPI.getFrontPage()

    const page = await GeneralAPI.getPageBySlug('/better-direct-mail')
    const data = page ? page[0] : {}

    const { banners } = await GeneralAPI.getACFBanners()
    data.banners = banners

    return {
        props: {
            data,
            hideTopNav: true,
            hideCartButton: true,
            hideLoginButton: true,
        },
        revalidate: 10, // In seconds
    }
}
